import React, { useEffect } from "react";
import { useMutation } from "react-query";
import { Button, Form, Input, Radio } from "antd";
import { modifyWebhook } from "../service/api";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";

export const ModifyWebhookForm = ({ businessAccountId, showModifyModal, webhook }) => {
    const [form] = Form.useForm();
    const queryClient = useQueryClient();

    // Session constants
    const currentUser = JSON.parse(sessionStorage.getItem('authUser'));
    const token = currentUser?.token;

    //Mutation
    const addWebhookMutation = useMutation(modifyWebhook);

    useEffect(() => {
        if (webhook) {
            form.setFieldsValue({
                description: webhook.description,
                url: webhook.url
            });
        }
    }, [webhook, form]);

    const modifyWebhookMethod = (data) => {
        const values = {
            'token': token,
            'webhookId': webhook.id,
            'body': data
        }

        addWebhookMutation.mutate(values, {
            onSuccess: () => {
                form.resetFields();
                showModifyModal(false);
                toast.success("Webhook modifié avec succès.")
                queryClient.invalidateQueries({
                    predicate: (query) => query.queryKey[0] === 'webhookList',
                });
            },
            onError: (error) => {
                console.error(error);
            }
        }
        )
    }

    return (
        <div>
            <Form
                className="mt-2"
                layout="vertical"
                form={form}
                style={{ width: "100%" }}
                onFinish={(values) => {
                    modifyWebhookMethod(values);
                }}
            >
                <Form.Item label="Description" name="description">
                    <Input placeholder="Décrivez votre webhook" />
                </Form.Item>
                <Form.Item label="Url du webhook" name="url">
                    <Input placeholder="Renseignez l'url" />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">Modifier le webhook</Button>
                </Form.Item>
            </Form>
        </div>
    )
}